<template>
  <div class="user-profile-header" v-on:click="toUserProfile" v-if="user && user.data">
    <div class="user-avatar small">
      <img :src="user.data.photoURL" v-if="user.data.photoURL"/>
      <i v-if="!user.data.photoURL" class="stg st-single-neutral-circle-2"/>
    </div>
    <div class="user-information">{{user.data.displayName}}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase/app";

export default {
  name: "User",
  computed: {
    ...mapGetters({
      user: "user",
      loggedIn: "loggedIn"
    })
  },
  mounted: function() {},
  methods: {
    toUserProfile: function() {
      if (this.$route.path === '/user/profile') {
        return;
      }
      this.$router.push({ path: "/user/profile" });
      document.getElementsByClassName("site-header")[0].classList.replace("expand-menu","collapse-menu"); 
      document.body.classList.replace("block","non-block");
    },
    logout: function() {
      let $this = this;
      firebase
        .auth()
        .signOut()
        .then(
          function() {
            $this.$store.dispatch("fetchUser", null);
            $this.$router.push({ path: "/login" });
          },
          function(error) {
            console.log(error);
          }
        );
    }
  }
};
</script>
<style>
</style>
